import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialService {
    

  constructor(public apiService: ApiService) { }

  private messageSource = new BehaviorSubject({});
  currentEditMaterial = this.messageSource.asObservable();

  changeEditMaterial(data: any) {
    this.messageSource.next(data)
  }

  getAllMaterialStock(body : any): Observable<any> {
    return this.apiService.post('materials/getAllMaterialStock', body);
  }
  
  getAllMaterials(body : any): Observable<any> {
    return this.apiService.post('materials/getMaterials', body);
  }
  GetAllMaterialsByCompanyId(body : any): Observable<any> {
    return this.apiService.post('materials/getMaterialsListByCompanyId', body);
  }
  getMaterialsByStatusId(body : any): Observable<any> {
    return this.apiService.post('materials/getMaterialsByStatusId', body);
  }
  getMaterialsByAgentId(body : any): Observable<any> {
    return this.apiService.post('materials/getMaterialsByAgentId', body);
  }
  addMaterial(body: any): Observable<any> {
    return this.apiService.post('materials/createMaterials', body);
  }
  importMaterial(body: any): Observable<any> {
    return this.apiService.post('materials/importMaterials', body);
  }
  
  editMaterial(body: any): Observable<any> {
    return this.apiService.post('materials/editMaterial', body)
  }

  getInternalCode(body: any): Observable<any> {
    return this.apiService.post('materials/beforeNewCreation', body)
  }

  inactiavteMaterial(body: any): Observable<any> {
    return this.apiService.post('materials/inActivateMaterial', body)
  }
  getMatInventory(body: any): Observable<any> {
    return this.apiService.post('materials/getMatInventoryDetails', body)
  }
  //addsubgrouptype
  addType(body: any): Observable<any> {
    return this.apiService.post('subunittype/createSubUnitType', body)
  }
  getSubGroupType(body: any): Observable<any> {
    return this.apiService.post('subunittype/getSubUnitTypes', body)
  }
  addUOM(body: any): Observable<any> {
    return this.apiService.post('unit/createunitmeasurement', body)
  }
  addAlergens(body: any): Observable<any> {
    return this.apiService.post('allergen/createAllergen', body)
  }
}
